import React, {createContext, useReducer} from "react";
import {InductAreaReducer} from "../reducers/InductAreaReducer";

export const InductAreaContext = createContext()

const InductAreaContextProvider = (props) => {
    const inductAreaInsight = {
        inductAreaData: []
    }
    const [viewModel, dispatch ] = useReducer(InductAreaReducer, inductAreaInsight)
    return (
        <InductAreaContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </InductAreaContext.Provider>
    )
}

export default InductAreaContextProvider


// WEBPACK FOOTER //
// ./src/components/induct/context/InductAreaContext.js